import { render } from "./ProjectPage.vue?vue&type=template&id=118e7f18&ts=true"
import script from "./ProjectPage.ts?vue&type=script&lang=ts&external"
export * from "./ProjectPage.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__